import React from "react";

const SelectField = ({ label, options = [], error, ...props }) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-semibold text-gray-900 mb-2">
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        {...props}
        className={`w-full px-0 py-3 border-0 border-b-2 transition-all duration-200 bg-transparent ${
          error
            ? "border-red-500 focus:border-red-500"
            : "border-gray-300 focus:border-teal-500"
        } ${props.disabled ? "bg-gray-50 cursor-not-allowed text-gray-500" : ""} ${props.className || ""}`}
      >
        <option value="">Select {label}</option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default SelectField;